
const RAILS_ENV = 'production';
const APP_URL = 'https://extsfy.carbon.click';

export { RAILS_ENV, APP_URL };